import { render, staticRenderFns } from "./StartsAPlan.vue?vue&type=template&id=62aca74a&scoped=true&"
import script from "./StartsAPlan.vue?vue&type=script&lang=js&"
export * from "./StartsAPlan.vue?vue&type=script&lang=js&"
import style0 from "./StartsAPlan.vue?vue&type=style&index=0&id=62aca74a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aca74a",
  null
  
)

export default component.exports